import IconCatch from '@/components/icons/icon-catch/icon-catch';
import MarkdownTextTailwind from '@/components/markdown/markdown-text-tailwind';

export default function NonQuantifiableRiskFactor() {
  return (
    <div className="modal-section">
      <div className="modal-section-header">
        <div className="modal-section-icon-container">
          <IconCatch icon="risk-impact" size="s" transparentBackground />
        </div>
        <h2 className="modal-section-title">Risk impact</h2>
      </div>
      <div className="modal-section-content">
        <MarkdownTextTailwind className="modal-section-text">
          {`Research on this topic is ongoing. While research shows this lowers your cancer risk, we are unable to
          quantify exact risk impact.`}
        </MarkdownTextTailwind>
      </div>
    </div>
  );
}
